import BiologicalMonitoring from '../../../views/corp/biological-monitoring/BiologicalMonitoring';
import ConfirmAutoclaveType from '../../../views/corp/biological-monitoring/AutoclaveConfirmationStatus';

const biologicalRoutes = [
  {
    path: '/corp/biological',
    element: <BiologicalMonitoring />
  },
  {
    path: '/corp/biological/autoclave-confirmation-status',
    element: <ConfirmAutoclaveType />
  }
];

export default biologicalRoutes;
